
/*old code*/
// import React, { Component } from "react";
// import classes from "./Faq.module.css";
// import axios from "../../../axios-order";
// import { toast } from "react-toastify";
// import Button from "@material-ui/core/Button";
// import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

// import Appbar from "../../../components/appBar/appBar";
// import { NavLink } from "react-router-dom";
// import Footer from "../../../components/footer/footer";
// import MuiTreeView from "material-ui-treeview";
// import Modal from "react-bootstrap/Modal";
// import Grid from "@material-ui/core/Grid";
// import BasicInputField from "../../../components/ui/basicInput";

// class Faq extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       ProfileData: null,
//       editProfileData: {
//         user_name: "",
//         user_email_id: "",
//         user_contact_no: "",
//         user_role: "",
//         status: ""
//       },
//       change_password: {},
//       editDrawer: false,
//       changePasswordDrawer: false,
//       original_tree: [],
//       addModalOpen: false,
//       parent_id: null
//     };
//   }

//   recursion = (first_tree, original_tree) => first_tree.map((v, i) => {
//     let parent_id = v.id;
//     const inside_tree = original_tree.filter(v => v.parent_id === parent_id);
//     if (inside_tree.length) {

//       return {
//         value: <div>{v.title}{v.file ? <Button size="small" variant="outlined" style={{ marginRight: "10px", marginLeft: "10px" }} onClick={() => this.downloadPdf(v.id, `${v.title}.pdf`)}>  Download</Button> : ""}   <Button
//           variant="contained"
//           color="primary"
//           size="small"
//           onClick={() => this.addButtonHandler(v.id)}

//         >Add</Button><Button
//         variant="contained"
//         color="error"
//         size="small"
//         onClick={() => this.deleteButtonHandler(v.id)}

//       >Delete</Button></div>,
//         nodes: this.recursion(inside_tree, original_tree),
//       };
//     } else {


//       return {
//         value: <div>{v.title}{v.file ? <Button size="small" variant="outlined" style={{ marginRight: "10px", marginLeft: "10px" }} onClick={() => this.downloadPdf(v.id, `${v.title}.pdf`)}>  Download</Button> : ""}<Button
//           variant="contained"
//           color="primary"
//           size="small"
//           onClick={() => this.addButtonHandler(v.id)}

//         >Add</Button><Button
//         variant="contained"
//         color="error"
//         size="small"
//         onClick={() => this.deleteButtonHandler(v.id)}

//       >Delete</Button></div>,
//         nodes: []
//       }
//     }

//   });


//   getFaqTree = () => {
//     axios.get("faq").then(res => {
//       let tree = res.data;
//       let first_tree = tree.filter(v => v.parent_id === 0)
//       this.setState({
//         original_tree: this.recursion(first_tree, tree)
//       })
//     })


//   }

//   downloadPdf = (faq_id, file_name) => {
//     axios.get(`download_faq/${faq_id}`).then(res => {
//       this.downloadBase64File(res.data.file, file_name);
//     })
//   }

//   deleteButtonHandler = (faq_id) => {
//     axios.delete(`faq/${faq_id}`).then(res => {
//       // this.downloadBase64File(res.data.file, file_name);
//       toast.success("File processing completed.", {
//         autoClose: 5000,
//         progress: 0,
//       });
//       this.getFaqTree();
//     })
//   }

//   downloadBase64File = (base64Data, fileName) => {
//     const linkSource = `data:application/pdf;base64,${base64Data}`;
//     const downloadLink = document.createElement("a");
//     downloadLink.href = linkSource;
//     downloadLink.download = fileName;
//     downloadLink.click();
//   };

//   componentDidMount = () => {
//     this.getFaqTree()
//   };

//   componentWillUnmount() {
//     ValidatorForm.removeValidationRule("isPasswordMatch");
//   }

//   getTitle = (event) => {
//     event.preventDefault();
//     const value = event.target.value;
//     this.setState((prevState) => ({
//       title: value
//     }));
//   };

//   backButton = () => {
//     this.props.history.goBack();
//   };

//   addButtonHandler = (parent_id) => {

//     this.setState({
//       addModalOpen: true,
//       parent_id: parent_id
//     })
//   }

//   addModalCloseHandler = () => {
//     this.setState({
//       addModalOpen: false
//     })
//   }

//   fileUploader = (event) => {
//     if (event.target.files[0]) {
//       const file_data = event.target.files[0];
//       let fileName = file_data.name;
//       this.setState({ file_name: fileName });
//       const reader = new FileReader();
//       reader.readAsDataURL(file_data);
//       const dis = this;
//       reader.onload = function () {
//         let file_value = reader.result;
//         dis.setState({ file: file_value });
//       };
//       document.getElementById("file_value").value = null;
//     }
//   };

//   onSubmitHandler = () => {
//     this.setState({ loading: true, modalShow: false });

//     axios
//       .post(`/faq`, {
//         file: this.state.file,
//         title: this.state.title,
//         parent_id: this.state.parent_id
//       })
//       .then((res) => {
//         if (
//           typeof res.data.error !== "undefined" ||
//           typeof res.data === "undefined"
//         ) {
//         } else {
//           toast.success("File processing completed.", {
//             autoClose: 5000,
//             progress: 0,
//           });
//           this.getFaqTree();
//         }
//       })
//       .catch((error) => {
//         toast.error(error.response.data, {
//           autoClose: 3000,
//           progress: 0,
//         });
//         this.getFaqTree();
//       }).finally(() => {
//         this.setState({
//           file: null,
//           title: null,
//           parent_id: null,
//           file_name: "",
//           loading: false
//         })
//       })
//   };

//   handleCloseLoader = () => {
//     this.setState({ loading: false });
//   };


//   render() {
//     return (
//       <>
//         <Modal
//           size="lg"
//           aria-labelledby="contained-modal-title-vcenter"
//           centered
//           show={this.state.addModalOpen}
//           onHide={this.addModalCloseHandler}
//           dialogClassName="modal-50w"
//         >
//           <ValidatorForm
//             ref="form"
//             onSubmit={this.onSubmitHandler}
//             onError={(errors) => console.log(errors)}
//           >
//             <Modal.Header closeButton>
//               <Modal.Title>Add modal</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//               {/* Form 26AS upload [UPLOADER(File input)] */}
//               <div
//                 style={{
//                   padding: "20px",
//                   marginBottom: "10px",
//                   boxShadow: "0px 0px 3px 0px #fff",
//                   boxShadow: "0px 1px 1px 1px #ddd",
//                 }}
//               >
//                 <Grid container spacing={3}>
//                   <Grid item xs={12}>
//                     <div
//                       style={{
//                         padding: "0px 20px 20px 20px",
//                         marginTop: "30px",
//                         marginBottom: "10px",
//                         boxShadow: "0px 0px 3px 0px #fff",
//                         boxShadow: "0px 1px 1px 1px #ddd",
//                       }}
//                     >
//                       <Grid container spacing={3}>
//                         <Grid item sm={3}>
//                           <p
//                             style={{ marginTop: "30px", fontSize: "16px" }}
//                           >
//                             Title
//                             <span style={{ color: "red" }}>*</span>:
//                           </p>
//                         </Grid>
//                         <Grid item sm={9}>
//                           <Grid container spacing={3}>

//                             <Grid item sm={9}>
//                               <BasicInputField
//                                 inputType="text"
//                                 name="title"
//                                 validator={["required"]}
//                                 errorMsg={["This field is required"]}
//                                 value={this.state.title ?? ""}
//                                 textOnchangeFunction={this.getTitle}
//                               />
//                             </Grid>
//                           </Grid>
//                         </Grid>
//                       </Grid>
//                     </div>
//                     <Grid container spacing={3}>
//                       <Grid item xs={3} md={3}>
//                         <Button
//                           size="small"
//                           variant="contained"
//                           component="label"
//                           fullWidth
//                           style={{ marginTop: "18px" }}
//                         >
//                           Browse
//                           <input
//                             id="file_value"
//                             name="pdf_file"
//                             accept="application/pdf"
//                             type="file"
//                             hidden
//                             onChange={this.fileUploader}
//                           />
//                         </Button>
//                       </Grid>
//                       <Grid item xs={9} md={9}>
//                         <ul style={{ width: "100%" }}>
//                           <li
//                             style={{
//                               display: "inline-block",
//                               width: "100%",
//                             }}
//                           >
//                             <TextValidator
//                               validators={["required"]}
//                               errorMessages={["This field is required"]}
//                               placeholder="Choose file"
//                               value={this.state.file_name}
//                               name="GSTJson_file_uploader"
//                               inputProps={{
//                                 readOnly: true,
//                               }}
//                               fullWidth
//                               size="small"
//                             />
//                           </li>
//                         </ul>
//                       </Grid>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </div>
//             </Modal.Body>
//             <Modal.Footer>
//               <Button
//                 size="small"
//                 variant="contained"
//                 type="submit"
//                 style={{ marginRight: "10px" }}
//               >
//                 Submit
//               </Button>
//               <Button
//                 size="small"
//                 variant="outlined"
//                 onClick={this.addModalCloseHandler}
//               >
//                 Close
//               </Button>
//             </Modal.Footer>

//           </ValidatorForm>
//         </Modal>

//         <Appbar />
//         <div className={classes.profileSection}>
//           <div className={classes.PesonalInfo}>
//             <div className={classes.ProfileHeader}>FAQ</div>
//             <div className={classes.profileBody}>
//               <ul>
//                 <li style={{ marginRight: "10px" }}>
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     onClick={this.backButton}
//                   >
//                     Back
//                   </Button>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     size="small"
//                     onClick={() => this.addButtonHandler(0)}
//                     style={{ marginLeft: "10px" }}
//                   >
//                     add
//                   </Button>

//                 </li>
//               </ul>
//               {/* ---profile data--- */}
//             </div>
//             {/* ---End--- */}
//             <MuiTreeView tree={this.state.original_tree} />
//           </div>
//         </div>
//         {/* ---Footer--- */}
//         <div className={classes.profileFooter}>
//           <Footer />
//         </div>
//         {/* ---Footer End--- */}
//       </>
//     );
//   }
// }
// export default Faq;


import React, { Component } from "react";
import classes from "./Faq.module.css";
import Appbar from "../../../components/appBar/appBar";
import Footer from "../../../components/footer/footer";
import Button from "@material-ui/core/Button";
import Modal from "react-bootstrap/Modal";

class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredId: null,
      loadingId: null,
      videoModalShow: false,
      activeBlobUrl: "",
      faqItems: [
        {
          id: 1,
          title: "How To - Connect Zoho Books Integration (Video)",
          videoUrl:
            "https://storcicwsprod001.blob.core.windows.net/26as-assets/Zoho%20Books%20Integration%20Video.mp4",
          description:
            "Set up and connect your Zoho Books account to the 26AS module in just 2 minutes. Automatically sync customer records, invoices, and collections—quick and seamless.",
        },
        {
          id: 2,
          title: "How To - GSTR - 1 Filing",
          videoUrl:
            "https://storcicwsprod001.blob.core.windows.net/gst-assets/GSTR-1%20Filing%20Video.mp4",
          description:
            "Learn how to selectively include, update, or exclude specific invoices and HSN details while filing your GSTR-1.",
        },
          {
          id: 3,
          title: "GSTR - 1 Selective Invoice Filing User Manual",
          docUrl:
            "https://storcicwsprod001.blob.core.windows.net/gst-assets/GSTR-1%20Selective%20Invoice%20Filing%20-%20User%20Manual.docx",
          description:
            "Learn how to selectively include, update, or exclude specific invoices and HSN details, validate them, and submit your GSTR-1 filing directly to the GST Portal",
        },
        {
          id: 4,
          title: "26AS Module User Manual",
          docUrl:
            "https://storcicwsprod001.blob.core.windows.net/26as-assets/26AS%20Reconciliation.docx",
          description:
            "Comprehensive user manual covering every feature of the 26AS module—from setup and data uploads to reconciliation, manual pairing, notifications, and more.",
        },
        {
          id: 5,
          title: "How To - Get Started with 26AS Reconciliation (Video)",
          videoUrl:
            "https://storcicwsprod001.blob.core.windows.net/26as-assets/26AS%20Video%20Walkthrough.mp4",
          description:
            "Complete video walkthrough of the 26AS module—from login to final reconciliation. Learn how to set up, upload data, reconcile, and send customer notifications.",
        },
        {
          id: 6,
          title: "How To - Add Tally Connector (Video)",
          videoUrl:
            "https://storcicwsprod001.blob.core.windows.net/tallyintegrations/Tally%20Connector%20Video.mp4",
          description:
            "Complete video walkthrough of the Tally Connector.",
        },
      ],
    };
  }

  handleItemClick = async (item) => {
    if (item.videoUrl) {
      // Azure Blob Storage isn't honoring Range requests for this account
      // (returns full file with 200 instead of 206 Partial Content), which
      // is why seeking/fast-forwarding was unreliable when the browser
      // streamed directly from the blob URL. Fetching the whole file once
      // into a local blob avoids this entirely: once the browser has the
      // full video in memory, seeking is instant and needs no further
      // network requests to Azure at all.
      try {
        this.setState({ loadingId: item.id });
        const response = await fetch(item.videoUrl);
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        this.setState({ activeBlobUrl: blobUrl, videoModalShow: true });
      } catch (err) {
        console.error("Video load failed:", err);
        alert("Sorry, the video could not be loaded. Please try again.");
      } finally {
        this.setState({ loadingId: null });
      }
    } else if (item.docUrl) {
      const googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
        item.docUrl
      )}&embedded=false`;
      window.open(googleViewerUrl, "_blank");
    }
  };

  closeVideoModal = () => {
    // Release the memory held by the blob URL once we're done with it
    if (this.state.activeBlobUrl) {
      window.URL.revokeObjectURL(this.state.activeBlobUrl);
    }
    this.setState({ videoModalShow: false, activeBlobUrl: "" });
  };

  backButton = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <>
        {/* Video Modal - plays from a local blob URL so seeking works
            instantly without depending on Azure Range request support */}
        <Modal
          show={this.state.videoModalShow}
          onHide={this.closeVideoModal}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Video Guide</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: 0, background: "#000" }}>
            {this.state.activeBlobUrl && (
              <video
                key={this.state.activeBlobUrl}
                width="100%"
                height="500px"
                controls
                autoPlay
                style={{ display: "block" }}
              >
                <source src={this.state.activeBlobUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button style={{ color: "red" }} onClick={this.closeVideoModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Appbar />
        <div className={classes.profileSection}>
          <div className={classes.PesonalInfo}>
            <div className={classes.ProfileHeader}>FAQ</div>
            <div className={classes.profileBody}>
              <ul>
                <li style={{ marginRight: "10px" }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={this.backButton}
                  >
                    Back
                  </Button>
                </li>
              </ul>
            </div>

            <div style={{ padding: "10px 20px" }}>
              {this.state.faqItems.map((item) => (
                <div
                  key={item.id}
                  onClick={() => this.handleItemClick(item)}
                  onMouseEnter={() => this.setState({ hoveredId: item.id })}
                  onMouseLeave={() => this.setState({ hoveredId: null })}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    padding: "14px 18px",
                    marginBottom: "12px",
                    borderRadius: "8px",
                    border: "1px solid #d0d8f0",
                    backgroundColor: "#f5f8ff",
                    cursor: "pointer",
                    transition: "box-shadow 0.2s",
                    boxShadow:
                      this.state.hoveredId === item.id
                        ? "0 2px 10px rgba(0,0,0,0.12)"
                        : "none",
                  }}
                >
                  <div
                    style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "50%",
                      backgroundColor: item.videoUrl ? "#e8f0fe" : "#fff3e0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px",
                      marginRight: "14px",
                      flexShrink: 0,
                    }}
                  >
                    {item.videoUrl ? "▶" : "📄"}
                  </div>

                  <div>
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "14px",
                        color: "#1a237e",
                        marginBottom: "4px",
                      }}
                    >
                      {item.title}
                      {item.videoUrl && (
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "#888",
                            marginLeft: "8px",
                          }}
                        >
                          {this.state.loadingId === item.id
                            ? "(loading video…)"
                            : ""}
                        </span>
                      )}
                    </div>

                    {this.state.hoveredId === item.id && (
                      <div
                        style={{
                          fontSize: "13px",
                          color: "#555",
                          lineHeight: "1.5",
                        }}
                      >
                        {item.description}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={classes.profileFooter}>
          <Footer />
        </div>
      </>
    );
  }
}

export default Faq;